import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoRm: CultureInfo = {
  name: 'rm',
  displayName: 'Romansh',
  iso3LanguageCode: 'roh',
  iso2LanguageCode: 'rm',
  ietfLanguageTag: 'rm',
  parent: null
};
